export default "__VITE_ASSET__B$skbWtH__ 1200w";